import { useHotjar } from '../../hooks/useHotjar';

interface HotjarComponentProps {
    appId: string;
}

export const HotjarComponent: React.FC<HotjarComponentProps> = ({ appId }) => {
    useHotjar(appId);
    return null;
}; 